import React from "react";
import { Box, Button, Typography } from "@mui/material";
import { Add } from "@mui/icons-material";
import moment from "moment";
import ScheduleEntryRow from "./ScheduleEntryRow";

function ScheduleEntryList({ entries, setEntries, isEditMode, lockAll }) {
  // n_id of the entry holding this batch's single "Send Immediately" slot. Derived from
  // the batch-wide holder id when present (sub-only edit forms render one entry, so the
  // in-form scan alone would miss a sibling that already uses Send Immediately).
  const immediateHolderId = entries.some((e) => e.batch_immediate_holder_id != undefined)
    ? entries.find((e) => e.batch_immediate_holder_id != undefined)?.batch_immediate_holder_id
    : (entries.some((e) => String(e.notification_send_type) === "1")
        ? entries.find((e) => String(e.notification_send_type) === "1")?.n_id
        : null);

  // Every entry already sent -> the whole batch is frozen
  const allEntriesSent =
    entries.length > 0 &&
    entries.every((e) => String(e?.notification_send_status) === "1");
  const addDisabled = allEntriesSent;

  const handleUpdate = (index, updatedEntry) => {
    const newEntries = [...entries];
    newEntries[index] = updatedEntry;
    setEntries(newEntries);
  };

  const handleRemove = (index) => {
    if (entries.length <= 1) return;
    setEntries(entries.filter((_, i) => i !== index));
  };

  const handleAdd = () => {
    if (allEntriesSent) return;
    setEntries([
      ...entries,
      {
        s_date: moment().format("DD-MM-YYYY"),
        e_date: "",
        notification_send_type: "0",
        n_date_time: "",
        show_on_home: 0,
        _uid: `entry_${Date.now()}_${Math.random()
          .toString(36)
          .substr(2, 9)}`
      }
    ]);
  };

  return (
    <Box>
      <Typography variant="subtitle1" fontWeight={600} gutterBottom>
        Schedule Dates
      </Typography>
      {entries.map((entry, index) => (
        <ScheduleEntryRow
          key={entry._uid || entry.n_id || index}
          entry={entry}
          index={index}
          totalEntries={entries.length}
          immediateHolderId={immediateHolderId}
          onUpdate={handleUpdate}
          onRemove={handleRemove}
          isEditMode={isEditMode}
          lockAll={lockAll}
        />
      ))}
      <Button
        startIcon={<Add />}
        variant="outlined"
        onClick={handleAdd}
        disabled={addDisabled}
        sx={{ mt: 1, textTransform: "none" }}
      >
        Add Schedule Date
      </Button>
    </Box>
  );
}
export default ScheduleEntryList;
